import { Box } from "@mui/material"
import type { FC } from "react"

import type { PayableApprovalsSearchParams } from "../../types/searchParams"

import { FilterChip } from "@/components/common/Filters"

interface PayableApprovalsFilterChipsProps {
  searchParams: PayableApprovalsSearchParams
  onRemove: () => void
}

const PERIOD_CHIP_PREFIX = "Period: "

const getPeriodChipLabel = (dueDateFrom: string | undefined, dueDateTo: string | undefined): string => {
  if (dueDateFrom && dueDateTo) return `${PERIOD_CHIP_PREFIX}${dueDateFrom} to ${dueDateTo}`
  if (dueDateFrom) return `${PERIOD_CHIP_PREFIX}from ${dueDateFrom}`
  if (dueDateTo) return `${PERIOD_CHIP_PREFIX}until ${dueDateTo}`
  return ""
}

export const PayableApprovalsFilterChips: FC<PayableApprovalsFilterChipsProps> = ({ searchParams, onRemove }) => {
  const { dueDateFrom, dueDateTo } = searchParams

  if (!dueDateFrom && !dueDateTo) return null

  return (
    <Box className='flex flex-wrap items-center gap-2' data-testid='payable-approvals.filter-chips'>
      <FilterChip
        testId='payable-approvals.filter-chips.due-date-range-chip'
        label={getPeriodChipLabel(dueDateFrom, dueDateTo)}
        onDelete={onRemove}
      />
    </Box>
  )
}
